import {trackPromise} from "react-promise-tracker";
import {getUrl} from "../../constants/urls";
import Call from "../../service/axiosV2";

export const getCustomFieldsAsync = (pageUrl) => {
  const url = pageUrl || getUrl("customFields");
  return trackPromise(Call.get(url));
};

export const createUpdateCustomFieldsAsync = (data = {}) => {
  const {id = ""} = data;
  const url = getUrl("customFields");
  if (id) {
    const patchUrl = `${url}${id}/`;
    return trackPromise(Call.patch(patchUrl, data));
  } else {
    return trackPromise(Call.post(url, data));
  }
};

export const deleteCustomFieldAsync = (id) => {
  const url = getUrl("customFields");
  const patchUrl = `${url}${id}/`;
  return trackPromise(Call.delete(patchUrl));
};

export const getCustomFieldChoicesAsync = (pageUrl) => {
  const url = pageUrl || getUrl("customFieldChoices");
  return trackPromise(Call.get(url));
};

export const createUpdateCustomFieldChoicesAsync = (data = {}) => {
  const {id = ""} = data;
  const url = getUrl("customFieldChoices");
  if (id) {
    const patchUrl = `${url}${id}/`;
    return trackPromise(Call.patch(patchUrl, data));
  } else {
    return trackPromise(Call.post(url, data));
  }
};

export const deleteCustomFieldChoiceAsync = (id) => {
  const url = getUrl("customFieldChoices");
  const patchUrl = `${url}${id}/`;
  return trackPromise(Call.delete(patchUrl));
};

export const getObjectTypesAsync = () => {
  const url = getUrl("objectTypes");
  return trackPromise(Call.get(url));
};

export const getRelatedObjectTypesAsync = () => {
  const url = getUrl("relatedObjectTypes");
  return trackPromise(Call.get(url));
};

export const getFieldTypesAsync = () => {
  const url = getUrl("fieldTypes");
  return trackPromise(Call.get(url));
};

export const getCustomFieldChoicesLabelValueAsync = () => {
  const url = getUrl("customFieldChoicesLabelValue");
  return trackPromise(Call.get(url));
};
